'use client';

import { I18nextProvider } from 'react-i18next';
import initTranslations from '@/app/i18n';
import { createInstance } from 'i18next';
import { ReactNode } from 'react';

const TranslationsProvider = ({
  children,
  locale,
  namespaces,
  resources,
}: {
  children: ReactNode;
  locale: string;
  namespaces: string[];
  resources: any;
}) => {
  const i18n = createInstance();

  initTranslations(locale, namespaces, i18n, resources);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default TranslationsProvider;

// 'use client';
// import { I18nextProvider } from 'react-i18next';
// import i18n from './i18n';

// export default function I18nClientProvider({ children }: Readonly<{ children: React.ReactNode }>) {
//   return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
// }
